import styled from "styled-components";

import { LoadingSkeletonBaseStyles } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

export const LoadingSkeletonTextContainer = styled(LoadingSkeletonBaseStyles)`
  height: 12px;

  width: ${({ width }) => width || "100%"};

  margin: 4px 0;
`;
